import { MenuItem } from 'primeng/api';
import { Component, OnInit, inject } from '@angular/core';
import { COPYRIGHTS, DEFAULT_MENU } from '@shared/properties';
import { CopyrightModel, Product } from '@oneeducation/app-core';
import { UserRoleService } from '@usermanagement/.';
import { NavigationEnd, Router } from '@angular/router';
import { LoaderService } from '@shared/services';
import { filter } from 'rxjs';
import setting from '@config/config.json';
import { USER_ENDPOINT } from '@shared/properties';
import {
  AuthService,
  LoggingService,
  ApiServiceService,
  FeatureFlagService
} from '@oneeducation/app-core';
import { FeatureFlagNames } from '@shared/enum/feature-flag-names';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit {
  private readonly userService = inject(UserRoleService);
  private readonly router = inject(Router);
  private readonly loaderService = inject(LoaderService);
  private readonly authService = inject(AuthService);
  private readonly apiService = inject(ApiServiceService);
  private readonly loggingService = inject(LoggingService);
  private readonly featureFlagService = inject(FeatureFlagService);

  copyrightModel: CopyrightModel;
  title = 'exclusions-app';
  public menuItems: MenuItem[];
  imagePath: string;
  isLoggedIn = false;
  isLoading: boolean;
  __URL = '';
  loggedInUserId: string | undefined = '';
  products: Product[] = [];
  imagePathUrl = '';
  isAppLauncherWidgetFeatureEnabled: boolean = false;
  isAppLoaded: boolean = false;

  constructor() {
    this.loaderService.isLoading.subscribe((loading) => {
      this.isLoading = loading;
    });

    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe((navEnd: NavigationEnd) => {
        this.__URL = navEnd.urlAfterRedirects;
      });
  }
  ngOnInit() {
    this.imagePath = 'assets/images/Education.svg';
    this.copyrightModel = {
      startingYear: COPYRIGHTS.StartingYear,
      toYear: COPYRIGHTS.ToYear,
      companyName: COPYRIGHTS.CompanyName
    };
    this.getMenus();

    // Get feature flag value for 'feature/enable_app_launcher_widget and feature/exc/enable_app_launcher_widget'
    // feature/enable_app_launcher_widget is used to globally enable/disable the app launcher widget in all products
    // feature/exc/enable_app_launcher_widget is used to enable/disable the app launcher widget in Exclusion product
    // To enable app launcher widget both flags must be enables
    this.featureFlagService.flagUpdatedReceived.subscribe((x) => {
      if (x === true) {
        this.isAppLauncherWidgetFeatureEnabled =
          this.featureFlagService.isFeatureEnabled(
            FeatureFlagNames.EnableAppLauncherWidget
          ) &&
          this.featureFlagService.isFeatureEnabled(
            FeatureFlagNames.EnableAppLauncherWidgetEXC
          );
        if (this.isAppLauncherWidgetFeatureEnabled) {
          this.loggedInUserId = this.authService.loggedInUserId;
          if (this.loggedInUserId) {
            this.userService.userInfoReceived.subscribe((x) => {
              if (x === true && this.userService.User) {
                this.getProducts();
              }
            });
          }
        }
      }
    });
  }

  private getMenus() {
    this.userService.userInfoReceived.subscribe((x) => {
      if (x === true) {
        this.isLoggedIn = true;
        if (this.userService.isLocalAuthorityUser) {
          // Local Authority menu
          this.menuItems = [
            {
              label: DEFAULT_MENU.Administration,
              items: [
                {
                  label: DEFAULT_MENU.ManageLAUsers,
                  routerLink: '/users/manageusers'
                },
                {
                  separator: true
                },
                {
                  label: DEFAULT_MENU.SupportDocumentMessage,
                  routerLink: '/supportdocument/managesupportdocumentmessage'
                }
              ]
            },
            { separator: true },
            {
              label: DEFAULT_MENU.ManageBases,
              routerLink: '/schools/managebases'
            }
          ];
          this.router.navigateByUrl('/users/manageusers');
        } else if (this.userService.isSchoolAdmin) {
          // School menu
          this.menuItems = [
            {
              label: DEFAULT_MENU.Administration,
              routerLink: '/users/manageusers'
            },
            { separator: true },
            {
              label: DEFAULT_MENU.Exclusions,
              routerLink: '/exclusions/pupildetails'
            }
          ];
          this.router.navigateByUrl('/exclusions/pupildetails');
        }
        this.featureFlagService.getFlags();
        this.isAppLoaded = true;
      }
    });
  }

  // Get the products assigned to logged in user
  getProducts() {
    this.apiService
      .getAll<
        Product[]
      >(USER_ENDPOINT.GetProductsByUserId.replace('{UserId}', (this.loggedInUserId ?? '').toString()), '')
      .subscribe({
        next: (data: any) => {
          if (data?.products) {
            // Remove the current product from products list
            this.products = data.products.filter(
              (product) =>
                product.product.toLowerCase() !==
                this.userService.product?.toLowerCase()
            );
            this.imagePathUrl = setting['sharedAssetsUrl'] ?? '';
          }
        },
        error: (error: any) => {
          this.loggingService.logError(error);
        }
      });
  }

  logout() {
    this.authService.logout();
  }
}
